module.exports = __webpack_public_path__ + "static/media/design_03@3x.5f967837.png";